<template>
    <v-form class="form-new-element">
        <v-container>
            <div>
                <v-text-field label="Titre de l'enquête" outlined></v-text-field>
                <v-select :items="recipients" item-text="name" item-value="_id" label="Choisir les destinataires" multiple chips deletable-chips outlined></v-select>
            </div>
            <div class="d-flex justify-center">
                <v-btn class="mt-4 mx-4 primary-button">Suivant</v-btn>
            </div>
            <div class="new-element-content free-text active">
                <div class="d-flex justify-center">
                    <v-icon color="primary drag-button">mdi-drag-horizontal-variant</v-icon>
                </div>
                <div class="d-flex align-center justify-space-between elt-title">
                    <h2 class="uppercase font-weight-bold">1. Texte libre</h2>
                    <v-menu>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn dark icon v-bind="attrs" v-on="on" class="dots-button">
                                <v-icon class="grey_">mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item v-for="(item, i) in actions" :key="i" @click="item.click(item.title)" class="cursor-pointer last-child-red">
                                <v-list-item-icon>
                                    <v-icon>{{item.icon}}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
                <v-text-field placeholder="Tapez votre question ici" outlined></v-text-field>
            </div>
            <div class="new-element-content unique-selection">
                <div class="d-flex align-center justify-space-between elt-title">
                    <h2 class="uppercase font-weight-bold">2. Sélection unique</h2>
                    <v-menu>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn dark icon v-bind="attrs" v-on="on" class="dots-button">
                                <v-icon class="grey_">mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item v-for="(item, i) in actions" :key="i" @click="item.click(item.title)" class="cursor-pointer last-child-red">
                                <v-list-item-icon>
                                    <v-icon>{{item.icon}}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
                <v-text-field placeholder="Tapez votre question ici" outlined></v-text-field>
                <v-text-field placeholder="Proposition 1" outlined prepend-inner-icon="mdi-checkbox-blank-circle-outline">
                    <template slot="append">
                        <v-icon>mdi-plus</v-icon>
                        <v-icon>mdi-minus</v-icon>
                    </template>
                </v-text-field>
                <v-text-field placeholder="Proposition 2" outlined prepend-inner-icon="mdi-checkbox-blank-circle-outline">
                    <template slot="append">
                        <v-icon>mdi-plus</v-icon>
                        <v-icon>mdi-minus</v-icon>
                    </template>
                </v-text-field>
            </div>
            <div class="new-element-content multiple-selection">
                <div class="d-flex align-center justify-space-between elt-title">
                    <h2 class="uppercase font-weight-bold">3. Sélection Multiple</h2>
                    <v-menu class="dots-button">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn dark icon v-bind="attrs" v-on="on" class="dots-button">
                                <v-icon class="grey_">mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item v-for="(item, i) in actions" :key="i" @click="item.click(item.title)" class="cursor-pointer last-child-red">
                                <v-list-item-icon>
                                    <v-icon>{{item.icon}}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
                <v-text-field placeholder="Tapez votre question ici" outlined></v-text-field>
                <v-text-field placeholder="Proposition 1" outlined prepend-inner-icon="mdi-checkbox-blank-circle-outline">
                    <template slot="append">
                        <v-icon>mdi-plus</v-icon>
                        <v-icon>mdi-minus</v-icon>
                    </template>
                </v-text-field>
                <v-text-field placeholder="Proposition 2" outlined prepend-inner-icon="mdi-checkbox-blank-circle-outline">
                    <template slot="append">
                        <v-icon>mdi-plus</v-icon>
                        <v-icon>mdi-minus</v-icon>
                    </template>
                </v-text-field>
            </div>
            <div class="new-element-content dropdown-list">
                <div class="d-flex align-center justify-space-between elt-title">
                    <h2 class="uppercase font-weight-bold">4. Sélection déroulante</h2>
                    <v-menu class="dots-button">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn dark icon v-bind="attrs" v-on="on" class="dots-button">
                                <v-icon class="grey_">mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item v-for="(item, i) in actions" :key="i" @click="item.click(item.title)" class="cursor-pointer last-child-red">
                                <v-list-item-icon>
                                    <v-icon>{{item.icon}}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
                <v-text-field placeholder="Tapez votre question ici" outlined></v-text-field>
                <v-text-field placeholder="Proposition 1" outlined prepend-inner-icon="mdi-checkbox-blank-circle-outline">
                    <template slot="append">
                        <v-icon>mdi-plus</v-icon>
                        <v-icon>mdi-minus</v-icon>
                    </template>
                </v-text-field>
                <v-text-field placeholder="Proposition 2" outlined prepend-inner-icon="mdi-checkbox-blank-circle-outline">
                    <template slot="append">
                        <v-icon>mdi-plus</v-icon>
                        <v-icon>mdi-minus</v-icon>
                    </template>
                </v-text-field>
            </div>
            <div class="new-element-content image-selection">
                <div class="d-flex align-center justify-space-between elt-title">
                    <h2 class="uppercase font-weight-bold">6. Sélection d'image</h2>
                    <v-menu class="dots-button">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn dark icon v-bind="attrs" v-on="on" class="dots-button">
                                <v-icon class="grey_">mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item v-for="(item, i) in actions" :key="i" @click="item.click(item.title)" class="cursor-pointer last-child-red">
                                <v-list-item-icon>
                                    <v-icon>{{item.icon}}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
                <v-text-field placeholder="Tapez votre question ici" outlined></v-text-field>
                <div class="d-flex flex-wrap form-img-content">
                    <div class="d-flex img-elt">
                        <v-img src="/images/ex_intervention.png"></v-img>
                    </div>
                    <div class="d-flex img-elt">
                        <v-file-input placeholder="Ajouter une photo" outlined dense prepend-icon="" class="d-flex img-elt"></v-file-input>
                    </div>
                </div>
            </div>
            <div class="new-element-content evaluation">
                <div class="d-flex align-center justify-space-between elt-title">
                    <h2 class="uppercase font-weight-bold">7. Evaluation</h2>
                    <v-menu class="dots-button">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn dark icon v-bind="attrs" v-on="on" class="dots-button">
                                <v-icon class="grey_">mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item v-for="(item, i) in actions" :key="i" @click="item.click(item.title)" class="cursor-pointer last-child-red">
                                <v-list-item-icon>
                                    <v-icon>{{item.icon}}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
                <v-text-field placeholder="Tapez votre question ici" outlined></v-text-field>
                <v-rating background-color="primary" color="primary" empty-icon="mdi-star-outline" full-icon="mdi-star" half-icon="mdi-star-halfFull" hover length="5" size="42" value="0"></v-rating>
            </div>
            <div class="d-flex justify-center">
                <v-btn class="mt-4 mx-4 primary-button outlined" @click="save(false)">Enregistrer</v-btn>
                <v-btn class="mt-4 mx-4 primary-button" @click="save(true)">Publier</v-btn>
            </div>
            <div class="d-flex justify-center">
                <v-btn icon class="add-button">
                    <v-icon color="white">mdi-plus</v-icon>
                </v-btn>
            </div>
        </v-container>
    </v-form>
</template>

<style lang="scss">

</style>

<script>
    import axios from 'axios'
    import { apiURL } from '@/../config'
    export default {
    name: 'EnquetesNew',
    props: ['actions'],
    data: () => {
        return {
            recipients: [],
            poll: {
                title: '',
                description: '',
                category: '',
                owners: '',
                activated: false
            },
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu: false
        }
    },
    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      }
    },
    async created () {
        try {
            // RECIPIENTS
            const RecipientsRes = await axios.get(`${apiURL}/data/apartments`)
            console.log(RecipientsRes)
            this.recipients = RecipientsRes.data.model
        } catch (e) {
            alert('Une erreur est survenue, veuillez réessayer.')
            console.log(e)
        }
    },
    methods: {
        formatDate (date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        // DRAFT OR PUBLISH NEW POLL
        async save (isDraft) {
            this.$store.dispatch('loading')
            try {
                this.poll.activated = isDraft
                await axios.post(`${apiURL}/polls/new`, this.poll)
                this.$router.push('/enquetes')
            } catch (e) {
                alert('Une erreur est survenue, veuillez réessayer.')
                console.log(e)
            } finally {
                this.$store.dispatch('stop_loading')
            }
        }
    }
}
</script>